import ajax from '../utils/request';
const admApi = {
  /********************************系统管理*********************************** */
  // 添加管理员
  addAdm(params) {
    return ajax({
      url: '/manage/add',
      type: 'post',
      params: params
    });
  },
  // 请求管理员列表
  getAdmList(params) {
    return ajax({
      url: '/manage/list',
      type: 'get',
      params: params
    });
  },
  // 修改权限
  updateAdm(params) {
    return ajax({
      url: '/manage/update',
      type: 'post',
      params: params
    });
  },
  // 删除权限
  delAdm(params) {
    return ajax({
      url: '/manage/del',
      type: 'delete',
      params: params
    });
  },
  // 请求管理员日志
  getAdminLog(params) {
    return ajax({
      url: '/log/operator',
      type: 'get',
      params: params
    });
  },
  // 编辑管理员操作日志
  editAdminLog(params) {
    return ajax({
      url: '/log/operator/modify',
      type: 'post',
      params: params
    })
  }
};
export default admApi;
